module.exports = __webpack_public_path__ + "static/media/datos_icon.b977cc7b.svg";